import { render } from "./ClaimInvoices.vue?vue&type=template&id=00c36a2e"
import script from "./ClaimInvoices.vue?vue&type=script&lang=js"
export * from "./ClaimInvoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__